import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "vw-text-box",
  templateUrl: "./text-box.component.html",
})
export class TextBoxComponent {
  @Input() label?: string;
  @Input() labelClass?: string;
  @Input() id?: string;
  @Input() type?: string;
  @Input() formControlProp?: string | number;
  @Input({ required: true }) parentForm!: FormGroup;
  @Input() clearButton?: boolean;
  @Input() buttonText?: string;
  @Input() buttonDisabled?: boolean;
  @Input() placeholder = "";

  @Input() invalid?: boolean;
  @Input() loading?: boolean;

  @Output() clear$ = new EventEmitter<void>();
  @Output() buttonClick$ = new EventEmitter<void>();

  constructor() {}

  clear(): void {
    this.clear$.emit();
  }

  buttonClick(): void {
    this.buttonClick$.emit();
  }
}
